import React from 'react';

import * as ST from './styled';

export interface ISliderControls {
    images: string[],
    activeImageIndex: number,
    onClick: (index: number) => void,
}

const SliderControls = ({ images, activeImageIndex, onClick }: ISliderControls) => {

    return (<>
        {images.map((url, index) => (
            <ST.ContainerPreview key={url}>
                <ST.Preview
                    url={url}
                    onClick={() => onClick(index)}
                    active={activeImageIndex === index}
                />
            </ST.ContainerPreview>
        ))}
    </>);
};

export default SliderControls;
